<template>
  <div>
    <app-tabs :tabs="tabs" />
    <router-view />
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'

// The tab bar keeps the legacy look; only the pages inside router-view use the new UI.
export default {
  name: 'ClimbingMountainCrewTabsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'climbing-mountain-crew', label: 'Crew' },
        { name: 'climbing-mountain-crew-legacy', label: 'Legacy' }
      ]
    }
  }
}
</script>
